import { Datagrid, TextField } from 'react-admin'

import { JobStatusDetail } from '../../helpers/constants'
import { getUserFullName } from '../../helpers/utils'
import { CustomReferenceField } from '../Common/CustomReferenceFields'
import CTList from '../List'

const onTaskClick = (record: any) => {
  const statusDetail = record.status_detail
  if (statusDetail === JobStatusDetail.ReviewingRateConfirmation) {
    return `/jobs/${record.id}/approve`
  } else {
    return `/jobs/${record.id}/show`
  }
}

const TaskList = (props: any) => (
  <CTList bulkActionButtons={false} {...props}>
    <Datagrid optimized rowClick={onTaskClick}>
      <CustomReferenceField
        source="assigned_to"
        sortable={false}
        label="Assigned Driver"
        baseUrl="/users"
        representationFunction={getUserFullName}
      />
      <CustomReferenceField
        source="team"
        sortable={false}
        label="Team"
        baseUrl="/teams"
        representationFunction={(team: any) => team.name}
      />
      <TextField source="status_detail" />
      <TextField source="load.source" label="Broker name" />
      <TextField source="load.source_human_id" label="Broker reference #" />
    </Datagrid>
  </CTList>
)

export default TaskList
